angular.module("vgresiduos").controller("EditSupplierMonitoringCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton(
				$rootScope,
				`organizacao/fornecedores/${$stateParams.supplierCode}/monitoramento/${$stateParams.monitoringId}`
			);
		};
	}
]);
